import { ErrorMessage } from '@/shared/utils';
import { Either, right, left } from '@shared-commons/utils';
import { UpComingLives, upComingLivesSchema } from '../../types/up-coming-lives';

export const upComingLivesValidator = (input: UpComingLives): Either<Error, UpComingLives> => {
  const result = upComingLivesSchema.safeParse(input);

  if (result.success) {
    return right({ ...result.data });
  } else {
    const errorMessages = result.error.errors
      .map((err) => `${err.path.join('.')} - ${err.message}`)
      .join(', ');
    return left(new Error(ErrorMessage('Validation error') + ': ' + errorMessages));
  }
};
